import { Component, Input } from '@angular/core';
import { OccConfig } from '@spartacus/core';

@Component({
    selector: 'app-quick-coverage-guide',
    templateUrl: './quick-coverage-guide.component.html',
    styleUrls: ['./quick-coverage-guide.component.scss'],
    standalone: false
})
export class QuickCoverageGuideComponent {
  @Input() quickCoverageDocs: any;
  baseUrl: String = this.config?.backend?.occ?.baseUrl + '/';
  constructor(private config: OccConfig) {}
}
